<template>
  <div class="component">
    <address id="address">
      <nav>
        <!-- <div class="inc">
          <span>マルキ鈴菊商店</span>
          <p>鈴木 真治</p>
        </div> -->
        <div class="location">
          <span>所在地</span>
          <p>〒319-1701</p>
          <p>茨城県北茨城市平潟町293</p>
        </div>
        <div class="tel">
          <span>TEL</span>
          <a href="tel:0293-46-5110">0293-46-5110</a>
        </div>
        <div class="fax">
          <span>FAX</span>
          <p>0293-46-7267</p>
        </div>
        <!-- <span>営業時間</span> -->
        <!-- <span>定休日</span> -->
      </nav>
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d12769.911138598189!2d140.792666!3d36.854981!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xd79bd50f1cc65985!2z44Oe44Or44Kt6Yi06I-K5ZWG5bqX!5e0!3m2!1sja!2sjp!4v1592305788424!5m2!1sja!2sjp"
        id="google-map"
        :height="`${iframe.height}px`"
        frameborder="0"
        allowfullscreen=""
        aria-hidden="false"
      ></iframe>
    </address>
  </div>
</template>

<script>
export default {
  data: () => ({
    iframe: {
      height: 0
    }
  }),
  mounted() {
    this.resize();
    document.addEventListener("resize", this.resize, { passive: false });
  },
  methods: {
    resize() {
      if (window.innerWidth >= 600) {
        this.iframe.height = document.getElementById("address").clientHeight;
      } else {
        this.iframe.height = 250;
      }
    }
  },
  beforeDestroy() {
    document.removeEventListener("resize", this.resize, { passive: false });
  }
};
</script>

<style lang="scss" scoped>
address {
  max-width: 960px;
  @media screen and (min-width: 600px) {
    & {
      display: flex;
      flex-direction: row-reverse;
    }
  }
  nav {
    margin: 0.5em 0;
    width: 100%;
    @media screen and (min-width: 600px) {
      & {
        width: 50%;
      }
    }
    div {
      margin: 0.5em 0;
      padding-left: 1em;
      p,
      a {
        padding-left: 1em;
      }
    }
  }
  iframe {
    width: 100%;
    @media screen and (min-width: 600px) {
      & {
        width: 50%;
      }
    }
  }
}
</style>
